import request from '@/router/axios'


// 修改计划时间
export function updateProjectPlanDate(query) {
  return request({
    url: '/projectPlan/updateProjectPlanDate',
    method: 'post',
    params: query
  })
}


// 修改勘察计划
export function insertOrUpdateProjectPlanProspecting(query) {
  return request({
    url: '/projectPlan/insertOrUpdateProjectPlanProspecting',
    method: 'post',
    params: query
  })
}
// 修改到货计划
export function insertOrUpdateProjectPlanDaohuo(query) {
  return request({
    url: '/projectPlan/insertOrUpdateProjectPlanDaohuo',
    method: 'post',
    params: query
  })
}

// 修改安装计划
export function insertOrUpdateProjectPlanInstallation(query) {
  return request({
    url: '/projectPlan/insertOrUpdateProjectPlanInstallation',
    method: 'post',
    params: query
  })
}

// 修改验收计划
export function insertOrUpdateProjectPlanArrival(query) {
  return request({
    url: '/projectPlan/insertOrUpdateProjectPlanArrival',
    method: 'post',
    params: query
  })
}

// 修改回访计划
export function insertOrUpdateProjectPlanReturnvisit(query) {
  return request({
    url: '/projectPlan/insertOrUpdateProjectPlanReturnvisit',
    method: 'post',
    params: query
  })
}
// 删除计划
export function delPlan(query) {
  return request({
    url: '/projectPlan/delPlan',
    method: 'post',
    params: query
  })
}
